import axios from "axios";
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}/admin`;

const saveNotification = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/notificationHistory/save`,
    param,
  );
  return data;
};

const notificationApi = {
  saveNotification,
};

export default notificationApi;
